import React from "react";
import { useSelector } from "react-redux";
import Item from "./Item";

export default function ListItems() {
  const { proveedorFiles } = useSelector((state) => state.proveedoresReducer);
  return (
    <div>
      {proveedorFiles.map((f, i) => (
        <Item key={i} file={f} />
      ))}
    </div>
  );
}
